import Vue from 'vue'
import Router from 'vue-router'
import BaseRouter from './Base'
import Main from '../view/Main'
import guards from './guards'

const chatRobot = () => import('../view/robot/aiChat')

// 路由守卫文件

Vue.use(Router)
let routers = []
routers = routers.concat(BaseRouter)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      redirect: '/welcome',
      linkActiveClass: 'active',
      children: routers
    },

    {
      path: '/aiChat',
      name: 'chatRobot',
      component: chatRobot
    },

    {
      path: '*',
      component: Error
    }
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: login
    // }
  ]
})
// 合并两个全局路由守卫
for (const key in guards) {
  router[key](guards[key])
}
export default router
